<div class="root-div">
  <div class="modal-header">
    <h4 class="modal-title header-13">Add New Column</h4>

    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
  </div>

  <div class="modal-body">
    <div>
      <label class="form-label body-14-semibold"> Column Name </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="columnName"
        (ngModelChange)="onInputChange()"
      />
      <span class="text-danger" style="font-size: 12px" *ngIf="errorMessage">{{
        errorMessage
      }}</span>
    </div>
  </div>

  <div class="modal-footer">
    <div class="d-flex justify-content-end">
      <button
        class="btn btn-accello-secondary mx-2"
        (click)="activeModal.dismiss('Cross click')"
      >
        Cancel
      </button>
      <button
        class="btn btn-accello-primary-light"
        (click)="close()"
        [disabled]="!isValid()"
      >
        Add
      </button>
    </div>
  </div>
</div>
